import { css } from '@emotion/react';

export const pressActionEffect = css`
    transition: transform 100ms ease-in-out;
    cursor: pointer;
    
    &:active {
        transform: scale(0.98);
    }
`;
